import { scaleLinear } from 'd3-scale';

export const colorScheme = {
  'Energy intensity measured in terms of primary energy and GDP': {
    color: ['#FDF5AD', '#E14946'],
    minmax: [1990, 2019],
    legend: 'MJ per 2017 USD PPP',
  },
  'Modern renewable share in total final energy consumption': {
    color: ['#FDF5AD', '#35B462'],
    minmax: [1990, 2019],
    legend: '%',
  },
  'Share of population with access to clean cooking': {
    color: ['#FDF5AD', '#00ACA0'],
    minmax: [2000, 2019],
    legend: '%',
  },
  'Share of population with access to electricity': {
    color: ['#FDF5AD', '#AD6AAA'],
    minmax: [2000, 2019],
    legend: '%',
  },
};

export function getMinMax(data) {
  return [
    Math.min(...data.map((d) => d.value)),
    Math.max(...data.map((d) => d.value)),
  ];
}

export function getRegionColorsByValue(data, indicator) {
  let result = [];
  let [min, max] = getMinMax(data);
  let colors = colorScheme[indicator].color;
  let tempCountries = [...data];
  let scale = scaleLinear([min, max], colors);
  tempCountries.forEach((country) => {
    let color = scale(Math.round(country.value * 100) / 100);
    result.push(['match', ['get', 'ISO3'], [country.ISO3], true, false]);
    result.push(color);
  });
  result.splice(0, 0, 'case');
  result.splice(result.length * 2 + 1, 0, '#fff');
  return result;
}
